import { render, staticRenderFns } from "./ClientSubscribers.vue?vue&type=template&id=e5cc4f1c&scoped=true"
import script from "./ClientSubscribers.vue?vue&type=script&lang=js"
export * from "./ClientSubscribers.vue?vue&type=script&lang=js"
import style0 from "./ClientSubscribers.vue?vue&type=style&index=0&id=e5cc4f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cc4f1c",
  null
  
)

export default component.exports